<template>
  <el-dialog
    :close-on-click-modal="false"
    title="项目列表"
    custom-class="project-dialog"
    :visible.sync="ProjectListVisible"
    :lock-scroll="false"
    width="70%"
    top="3vh"
  >
    <div>
      <div class="eig-filter clearfix">
        <div class="eig-rght pa-xs">
          <el-button type="primary" @click="addclassDialog">添加项目</el-button>
        </div>
      </div>
      <el-dialog
        append-to-body
        :close-on-click-modal="false"
        title="新增报名项目"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        :lock-scroll="false"
        top="3vh"
        width="50%"
      >
        <el-form
          :rules="projectRules"
          ref="projectForm"
          :model="formProject"
          label-width="130px"
        >
          <el-form-item prop="name" label="项目名称：">
            <el-input :maxlength="200" v-model="formProject.name"></el-input>
          </el-form-item>
          <el-form-item prop="money" label="项目金额：">
            <el-input-number
              v-model="formProject.money"
              :precision="2"
              :min="0.01"
              :step="0.01"
              :max="100000000"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="报名时间：" prop="projectTime">
            <el-date-picker
              v-model="formProject.projectTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="早鸟优惠：" prop="birdDiscount">
            <el-switch v-model="formProject.birdDiscount"> </el-switch>
          </el-form-item>
          <el-form-item
            prop="birdMoney"
            label="早鸟金额："
            v-if="formProject.birdDiscount"
          >
            <el-input-number
              v-model="formProject.birdMoney"
              :precision="2"
              :min="0.01"
              :step="0.01"
              :max="100000000"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="早鸟报名时间："
            prop="birdTime"
            v-if="formProject.birdDiscount"
          >
            <el-date-picker
              v-model="formProject.birdTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="年龄限制：" prop="ageLimit">
            <input-number-range
              :precision="0"
              style="width: 400px"
              v-model="formProject.ageLimit"
            ></input-number-range>
          </el-form-item>
          <el-form-item label="人数限制：" prop="numberLimit">
            <el-input-number
              v-model="formProject.numberLimit"
              :precision="0"
              :step="1"
              :min="0"
              :max="100000"
            ></el-input-number>
          </el-form-item>
          <!-- <el-form-item label="不叠加团报优惠：" prop="notGroupDiscount">
            <el-switch v-model="formProject.notGroupDiscount"> </el-switch>
          </el-form-item> -->
          <el-form-item label="证书审核：" prop="certificateReview">
            <el-switch v-model="formProject.certificateReview"> </el-switch>
          </el-form-item>
          <el-form-item
            label="证书名称："
            v-if="formProject.certificateReview"
            prop="certificateName"
          >
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入证书名称"
              v-model="formProject.certificateName"
            >
            </el-input>
            <p>告知用户上传哪些证书,若是多个证书请用“、”分开</p>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = !dialogVisible" size="small"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="submitForm('projectForm')"
            size="small"
            >确 认</el-button
          >
        </div>
      </el-dialog>
      <!-- <el-dialog
        append-to-body
        :close-on-click-modal="false"
        :title="!isEdit?'新增项目':'编辑项目'"
        :visible.sync="dialogVisible"
        width="40%"
      >
        <div class="px-xs">
          <el-form
            :model="addClassForm"
            :rules="rules"
            ref="addClassFormRef"
            label-width="100px"
          >
            <el-form-item
              :label="!isEdit?'添加项目':'编辑项目'"
              prop="addclass"
            >
              <el-input v-model="addClassForm.addclass"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('addClassFormRef')"
          >确 定</el-button>
        </span>
      </el-dialog> -->
      <el-table ref="filterTable" :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="name" label="项目名称"></el-table-column>
        <el-table-column prop="isShow" label="金额" width="80">
          <template slot-scope="scope">
            {{ "￥" + scope.row.money }}
          </template>
        </el-table-column>
        <el-table-column
          prop="birdDiscount"
          label="早鸟优惠"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.birdDiscount ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="isShow" label="年龄限制" width="100">
          <template slot-scope="scope">
            {{ scope.row.ageLimit | parNumberRange() }}
          </template>
        </el-table-column>
        <el-table-column width="100" prop="numberLimit" label="人数限制">
        </el-table-column>
        <el-table-column width="130" prop="projectTime" label="开始时间">
          <template slot-scope="scope">
            {{ scope.row.effectStartTime | formatTime() }}
          </template>
        </el-table-column>
        <el-table-column width="130" prop="projectTime" label="结束时间">
          <template slot-scope="scope">
            {{ scope.row.effectEndTime | formatTime() }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <!-- <el-button
            type="info"
            size="mini"
            @click="reply(scope.row)"
          >修改</el-button> -->
            <!-- <el-tooltip
              effect="dark"
              content="上移"
              placement="top"
            >
              <el-button
                size="small"
                icon="el-icon-top"
                circle
                @click="moveInfo(scope.row,scope.$index,'up')"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="下移"
              placement="top"
            >
              <el-button
                circle
                icon="el-icon-bottom"
                size="small"
                @click="moveInfo(scope.row,scope.$index,'down')"
              ></el-button>
            </el-tooltip> -->
            <el-tooltip effect="dark" content="复制" placement="top">
              <el-button
                size="small"
                icon="el-icon-document-copy"
                circle
                @click="copeInfo(scope.row, scope.$index)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="上移" placement="top">
              <el-button
                size="small"
                icon="el-icon-top"
                circle
                @click="moveInfo(scope.row, scope.$index, 'up')"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="下移" placement="top">
              <el-button
                circle
                icon="el-icon-bottom"
                size="small"
                @click="moveInfo(scope.row, scope.$index, 'down')"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="编辑" placement="top">
              <el-button
                circle
                icon="el-icon-edit"
                size="small"
                @click="editInfo(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top">
              <el-button
                circle
                size="small"
                icon="el-icon-delete"
                @click="deleteInfo(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        append-to-body
        :close-on-click-modal="false"
        title="删除"
        :visible.sync="dialogFormVisible"
        :lock-scroll="false"
        width="35%"
      >
        <span>是否删除 "{{ deleteObj.title }}" </span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small"
            >取 消</el-button
          >
          <el-button type="primary" @click="haddledeleteInfo" size="small"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="ProjectListVisible = false" size="small"
        >取 消</el-button
      >
      <el-button type="primary" @click="saveProject" size="small"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import InputNumberRange from "@/components/inputNumberRange.vue";
export default {
  components: {
    InputNumberRange,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
    registTime: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    ProjectListVisible(value) {
      this.$emit("update:visible", value);
    },
    visible: {
      handler(value) {
        this.ProjectListVisible = value;
      },
      immediate: true,
    },
    value: {
      handler(value) {
        this.tableData = JSON.parse(JSON.stringify(value));
      },
      immediate: true,
    },
  },
  filters: {
    parNumberRange(value) {
      debugger;
      if (value && value[0] && value[1]) {
        return `${value[0]} ~ ${value[1]}`;
      } else {
        return "";
      }
    },
    formatTime(date, separate = "/") {
      if (!date) return "";
      function formatNumber(n) {
        n = n.toString();
        return n[1] ? n : "0" + n;
      }
      date = new Date(date);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return [year, month, day].map(formatNumber).join(separate);
    },
  },
  data() {
    return {
      dialogVisible: false,
      ProjectListVisible: this.visible,
      // 绑定表单数据
      formProject: {
        id: "",
        name: "",
        money: 0,
        birdMoney: 0,
        numberLimit: 99999,
        projectTime: [],
        birdTime: [],
        ageLimit: [],
        notGroupDiscount: false,
        certificateReview: false,
        birdDiscount: false,
        certificateName: "",
      },
      //   rules: {
      //     addclass: [
      //       {
      //         required: true,
      //         message: "请输入需要添加的类名称",
      //         trigger: "blur",
      //       },
      //       { min: 2, max: 10, message: "长度在 2 到 10个字符", trigger: "blur" },
      //     ],
      //   },
      projectRules: {
        name: [{ required: true, message: "请输入项目名称" }],
        money: [{ required: true, message: "请输入项目金额" }],
        projectTime: [{ required: true, message: "请选择项目时间" }],
        birdMoney: [{ required: true, message: "请输入早鸟金额" }],
        birdTime: [{ required: true, message: "请选择早鸟报名时间" }],
        certificateName: [{ required: true, message: "请输入证书名称" }],
      },
      tableData: [],
      // 分页
      page: {
        page_size: 5,
        page_index: 1,
        blogs: [],
        count: 0,
      },
      // 删除博客的数据对象
      deleteObj: {
        title: "",
        id: "",
      },
      // 控制弹窗
      dialogFormVisible: false,
      isEdit: false,
    };
  },
  mounted() {},
  methods: {
    copeInfo(row, index) {
      let newRow = JSON.parse(JSON.stringify(row))
      delete newRow.id
      this.tableData.splice(index, 0,newRow);
    },
    // 移动
    moveInfo(row, index, direction) {
      let tableData = this.tableData;
      if (direction == "up") {
        if (index == 0) {
          return this.$message.info("无法再上移了！");
        }
        const element = tableData[index];
        tableData.splice(index, 1);
        tableData.splice(index - 1, 0, element);
      } else if (direction == "down") {
        if (index == this.tableData.length - 1) {
          return this.$message.info("无法再下移了！");
        }
        const element = tableData[index];
        tableData.splice(index, 1);
        tableData.splice(index + 1, 0, element);
      }
    },
    saveProject() {
      console.log(this.tableData);
      this.$emit("input", this.tableData);
      this.ProjectListVisible = false;
    },
    submitForm(formName) {
      if (
        this.formProject.birdDiscount &&
        this.formProject.money < this.formProject.birdMoney
      ) {
        return this.$message.error("早鸟报名金额不能大于项目报名金额");
      }
      let effectStartTime = new Date(this.formProject.projectTime[0]).getTime();
      let effectEndTime = new Date(this.formProject.projectTime[1]).getTime();
      let birdStartTime = new Date(this.formProject.birdTime[0]).getTime();
      let birdEndTime = new Date(this.formProject.birdTime[1]).getTime();
      if (this.formProject.birdDiscount && birdStartTime < effectStartTime) {
        return this.$message.error("早鸟报名时间不能小于项目报名时间");
      }
      if (this.formProject.birdDiscount && birdEndTime > effectEndTime) {
        return this.$message.error("早鸟报名时间不能大于项目报名时间");
      }

      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.dialogVisible = false;
            this.formProject.effectStartTime = effectStartTime;
            this.formProject.effectEndTime = effectEndTime;
            this.formProject.birdStartTime = birdStartTime;
            this.formProject.birdEndTime = birdEndTime;
          } else {
            this.tableData.push({
              name: this.formProject.name,
              money: this.formProject.money,
              birdMoney: this.formProject.birdMoney,
              numberLimit: this.formProject.numberLimit,
              ageLimit: this.formProject.ageLimit,
              certificateReview: this.formProject.certificateReview,
              birdDiscount: this.formProject.birdDiscount,
              notGroupDiscount: this.formProject.notGroupDiscount,
              certificateName: this.formProject.certificateName,
              effectStartTime: effectStartTime,
              effectEndTime: effectEndTime,
              birdStartTime: birdStartTime,
              birdEndTime: birdEndTime,
            });
          }

          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    }, // 占位符方式
    haddledeleteInfo() {
      this.$http
        .delete(`match/deleteClass/?id=${this.deleteObj.id}`)
        .then((res) => {
          this.dialogFormVisible = false;
          this.page = {
            page_size: 5,
            page_index: 1,
            blogs: [],
            count: 0,
          };
          this.getInfo();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 删除
    deleteInfo(row) {
      this.tableData.splice(
        this.tableData.findIndex((item) => {
          return item == row;
        }),
        1
      );
    },
    // 编辑
    editInfo(row) {
      this.formProject = row;
      let projectTime = [];
      projectTime.push(row.effectStartTime);
      projectTime.push(row.effectEndTime);
      this.$set(this.formProject, "projectTime", projectTime);
      let birdTime = [];
      if (row.birdStartTime) {
        birdTime.push(row.birdStartTime);
      }
      if (row.birdEndTime) {
        birdTime.push(row.birdEndTime);
      }

      this.$set(this.formProject, "birdTime", birdTime);
      this.$set(this.formProject, "certificateReview", !!row.certificateReview);
      this.$set(this.formProject, "birdDiscount", !!row.birdDiscount);
      this.$set(this.formProject, "notGroupDiscount", !!row.notGroupDiscount);
      this.isEdit = true;
      this.dialogVisible = true;
      // this.$forceUpdate()
    },
    // 当前页改变
    handleCurrentChange(currentPageNumber) {
      console.log(currentPageNumber);
      this.page.page_index = currentPageNumber;
      this.getInfo();
    },
    // 当前每页数据量改变
    handleSizeChange(pageDataCount) {
      console.log(pageDataCount);
      this.page.page_size = pageDataCount;
      this.getInfo();
    },

    addclassDialog() {
      this.isEdit = false;
      this.formProject = {
        id: "",
        name: "",
        money: 0,
        birdMoney: 0,
        numberLimit: 99999,
        projectTime: [],
        birdTime: [],
      };

      // if (!this.formProject.projectTime.length) {
      //   this.formProject.projectTime = JSON.parse(
      //     JSON.stringify(this.registTime)
      //   );
      // }
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped></style>
